<div class="container-fluid">
  <div class="header-container" style="display: flex;">
    <div class="page-header" style="margin-top: auto;margin-bottom: auto;">
      <span class="fa fa-wrench"></span>{{ "bikeshop.menu.services" | translate }}
    </div>
    <div class="status-filter">
      <div *ngFor="let status of statusList; let i = index" class="status-item"
        [ngClass]="{ active: activeItem.id === status.id, loading: loading }" (click)="menuSelected(i)">
        <div class="left-bar"></div>
        <div class="status-metric">{{ status.metric }}</div>
        <div class="status-label">{{ status.label }}</div>
      </div>
    </div>
  </div>
  <div class="loading" *ngIf="loading">
    <div class="loader"></div>
  </div>

  <div class="content dashboard-service" style="margin-top:16px!important">
    <div class="row">
      <div class="col-md-4">
        <div *ngIf="linkedPartners && linkedPartners.length > 1">
          <div class="label">
            {{ 'bikeshop.menu.services_fromstore' | translate }}
          </div>
          <div>
            <p-multiSelect [options]="linkedPartners" [(ngModel)]="selectedPartners" placeholder="Select a store"
              optionLabel="partnerName" (onChange)="updateFilter($event.value)"></p-multiSelect>
          </div>
        </div>
      </div>
      <div class="col-md-4"></div>
      <div class="col-md-4" style="display: flex; justify-content: flex-end; align-items: flex-end;">

        <hub-button class=" f-right " *ngIf="this.partner.UseNewJobCard && this.partner.PartnerType === 1"
                    [title]="'workshop.calendar.scan' | translate"
                    [text]="'workshop.calendar.scan' | translate"
                    [style]="'secondary'"
                    [size]="'md'" [icon]="'scan'" (buttonClick)="scheduleServiceUsingBarcode()">
        </hub-button>
        <div style="padding:6px"></div>
        <hub-button class=" f-right "
                    [title]="'workshop.calendar.schedule' | translate"
                    [text]="'workshop.calendar.schedule' | translate"
                    [style]="'secondary'"
                    [size]="'md'" [icon]="'memo-pencil'" (buttonClick)="scheduleService()">
        </hub-button>



        <!--<button pButton (click)="scheduleService()" class="p-button-raised accent"
          label="{{'bikeshop.modal.shedule_service.schedule_service' | translate}}" style="width: 200px;"></button>-->
      </div>
    </div>

    <div *ngIf="statusList && statusList.length > 0" class="margin-top-16">
      <div>
        <div>
          <p-table #jobCardsTable [columns]="routeData === 'open' ? openColumns : columns" [value]="jobCards">
            <ng-template pTemplate="caption">
              <div style="display: flex;" class="mb-2">
                <div class="filter-container" *ngIf="routeData === 'open' && filters.length > 1">
                  <div *ngFor="let filter of filters"><span [ngClass]="{'selected': filter === selectedFilter}"
                      (click)="selectedFilter=filter"
                      *ngIf="getStatusDescription(filter, '') !== ''">{{getStatusDescription(filter, '')}}</span>
                  </div>
                </div>
                <div style="margin-left: auto;">
                  <div class="p-inputgroup">
                    <input type="text" pInputText size="30" placeholder="{{ 'general.search' | translate }}"
                      (input)="jobCardsTable.filterGlobal($event.target['value'] , 'contains')" style="width:auto" />
                    <!--                    todo (dcorbett $event.target.value )-->
                    <span class="p-inputgroup-addon"><i class="fa hubtiger-search"></i></span>
                  </div>
                </div>
                <span style="cursor: pointer;align-self: center;margin-left: 16px; color: #151A2A;"
                  (click)="downloadFile()"><i class="fa fa-download fa-2x" aria-hidden="true"></i></span>
              </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th style="overflow: visible;width: 44px;">
                  <p-checkbox [binary]="true" [(ngModel)]="globalSelectValue" [disabled]="busyBulkActioning"
                    (onChange)="globalSelected($event)"></p-checkbox>
                </th>
                <!-- <th style="width: 10px"></th> -->
                <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''"
                  [ngStyle]="{'width': col.type === 'action' ? '215px' : 'auto'}">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" style="vertical-align: middle;" *ngIf="col.type !== 'action'">
                  </p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-jobcard let-columns="columns">
              <tr [pSelectableRow]="jobcard" *ngIf="selectedFilter === 0 || selectedFilter === jobcard.StatusID">
                <td style="overflow: visible;">
                  <p-checkbox [(ngModel)]="jobcard.selected" [disabled]="busyBulkActioning"
                    [binary]="true"></p-checkbox>
                </td>
                <!-- <td style="display: flex;"><div class="status-indicator" ngClass="{{getStatusStyle(jobcard.StatusID)}}"></div></td> -->
                <td *ngFor="let col of columns">
                  <div *ngIf="col.type == 'jobcardno'">
                    <div (click)="openJobCard(jobcard.ID, jobcard.PartnerID)"><u>
                        {{ jobcard[col.field] }}</u>
                    </div>
                  </div>
                  <div *ngIf="col.type !== 'action' && col.type !== 'jobcardno' && col.type !== 'status'"
                    [ngClass]="{orange : routeData === 'open' && col.field === 'DateCheckedIn' && jobcard.DateCheckedIn !== jobcard.OriginalBookInDate}">
                    {{
                    col.type === "date"
                    ? (jobcard[col.field] | DateFormatPipe: displayDateTimeFormat)
                    : jobcard[col.field]
                    }}
                  </div>
                  <!--                  <div *ngIf="col.type === 'status'" class="status  "-->
                  <!--                       ngClass="{{getStatusStyle(jobcard.StatusID)}}">-->
                  <!--                    {{getStatusDescription(jobcard.StatusID, jobcard.StatusDescription)}}-->
                  <!--                  </div>-->
                  <div class="chip " *ngIf="col.type === 'status'"
                    ngClass="{{getStatusStyle(jobcard.StatusID) +'-iso'}}">
                    <span class="chip-text job-status-text">
                      <span>{{getStatusDescription(jobcard.StatusID, jobcard.StatusDescription)}}</span>
                    </span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="bulk-action-container" [ngClass]="{'active': isServicesSelected()}">
  <div *ngIf="busyBulkActioning" style="margin-top: 16px;display: flex;justify-content: center;">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
    </p-progressSpinner>
  </div>
  <div *ngIf="!busyBulkActioning">
    <button pButton type="button" class="p-button-raised accent" label="{{
      'bikeshop.services.bulk_action.cancel_jobs' | translate
    }}" (click)="bulkCancel()" [disabled]="!canBulkCancel() || busyBulkActioning"></button>
  </div>
  <div *ngIf="!busyBulkActioning">
    <button pButton type="button" class="p-button-raised accent" label="{{
      'bikeshop.services.bulk_action.collect_jobs' | translate
    }}" (click)="bulkCollect()" [disabled]="!canBulkCollect() || busyBulkActioning"></button>
  </div>
  <div *ngIf="!busyBulkActioning">
    <button pButton type="button" class="p-button-raised accent" label="{{
      'bikeshop.services.bulk_action.complete_jobs' | translate
    }}" (click)="bulkComplete()" [disabled]="!canBulkComplete() || busyBulkActioning"></button>
  </div>
  <div *ngIf="!busyBulkActioning && partner.OffersCollections">
    <button pButton type="button" class="p-button-raised accent" label="{{
      'bikeshop.services.bulk_action.deliver_jobs' | translate
    }}" (click)="bulkDeliver()" [disabled]="!canBulkDeliver() || busyBulkActioning"></button>
  </div>
</div>

<p-confirmDialog></p-confirmDialog>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
<p-dialog [(visible)]="displayCancellation">
  <div>
    <div>
      {{'bikeshop.services.bulk_action.cancel_jobs_confirmation' | translate : {count: getSelectedCount()} }}
    </div>
    <div>
      <div class="row margin-top-8">
        <div class="col-md-4 label">
          {{ "bikeshop.modal.update_job_card.job_card.cancel_reason" | translate }}:
        </div>
        <div class="col-md-8 value">
          <p-dropdown [options]="cancellationreasons" [(ngModel)]="selectedCancellationReason" placeholder="{{
            'bikeshop.modal.update_job_card.job_card.select_a_cancellation_reason'
              | translate
          }}" (ngModelChange)="beginJobCancellation()"></p-dropdown>
        </div>
      </div>
      <div class="row margin-top-8" *ngIf="showCancellationOtherReason">
        <div class="col-md-4 label">
          {{ "bikeshop.cancellation_reason.specify_reason" | translate }}:
        </div>
        <div class="col-md-8 value">
          <input pInputText type="text" [(ngModel)]="cancellationOtherReason" />
        </div>
      </div>
    </div>
  </div>
  <p-footer>
    <button type="button" pButton label="{{ 'general.no' | translate }}"
      (click)="displayCancellation = false;"></button>
    <button type="button" pButton label="{{ 'bikeshop.services.bulk_action.cancel_jobs' | translate }}"
      [disabled]="selectedCancellationReason === null || selectedCancellationReason === undefined || (selectedCancellationReason === 0 && !cancellationOtherReason)"
      (click)="bulkUpdate(100)"></button>
  </p-footer>
</p-dialog>
